export default "__VITE_ASSET__B9Jr0N5s__"